const scheduledServicesCalendarFilterModal = {
  filter: 'FILTROS',
  clear: 'Limpar Filtros',
  site: 'Sites',
  user: 'Responsável',
  groups: 'Grupo',
  place: 'Local',
  area: 'Departamentos',
  company: 'Empresa Terceira',
  equipmentModel: 'Tipo do Equipamento',
  frequencies: 'Frequências',
  serviceTypes: 'Tipos de Serviços',
  cancel: 'CANCELAR',
  ok: 'APLICAR',
};

export default scheduledServicesCalendarFilterModal;
